import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { colors } from "../../../ui/colors";
import { Key, Lock } from "@mui/icons-material";
import formatMMSS from "../helpper/formatMMSS";

type Props = {
  unlocked: boolean;
  onUnlock: () => void;
  onLock?: () => void;
  unlockSeconds?: number;
  remainingSeconds?: number;
};

export const VaultOpen: React.FC<Props> = ({ unlocked, onUnlock, unlockSeconds, remainingSeconds }) => {
  return (
    <Box sx={{ flex: 1 }}>
      <Box
        sx={{
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          textAlign: "center",
        }}
      >
        <Box sx={{ position: "relative", mb: 2 }}>
          <Box
            sx={{
              width: 100,
              height: 100,
              bgcolor: "var(--fx-surface-base, #FFFFFF)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {unlocked ? <Key sx={{ fontSize: 48, color: colors.orange.base }} /> : <Lock sx={{ fontSize: 48, color: colors.gray.base }} />}
            {/* Icono de candado, cambia de color según el estado de desbloqueo */}
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: 8,
              right: 4,
              bgcolor: colors.orange.base,
              color: "white",
              width: 24,
              height: 24,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
              fontWeight: 900,
              border: "3px solid var(--fx-surface-base, #FFFFFF)",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          ></Box>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 800, mb: 1, color: "var(--fx-surface-text, #0F172A)" }}>
          {unlocked ? "Vault Unlocked" : "Vault Locked"}
        </Typography>

        <Typography variant="body2" sx={{ color: "var(--fx-surface-textsecondary, #64748B)", maxWidth: 360, mb: 1, lineHeight: 1.6 }}>
          {unlocked
            ? "You can now open cards and view passwords (only the ones that are NOT locked)."
            : "You can’t open cards or view passwords until you unlock."}
        </Typography>

        {unlocked ? (
          <Typography variant="caption" sx={{ color: colors.orange.base, fontWeight: 800, letterSpacing: 0.5, mb: 3 }}>
            Auto-lock in {formatMMSS(remainingSeconds ?? 0)}
          </Typography>
        ) : null}

        {!unlocked ? (
          <Button
            onClick={onUnlock}
            variant="contained"
            startIcon={<Key />}
            sx={{
              borderRadius: 3,
              width: "fit-content",
              background: "var(--fx-surface-base, #FFFFFF)",
              textTransform: "none",
              color: colors.orange.base,
              fontWeight: 700,
              boxShadow: "none",
              transition: "all 0.1s ease-in-out",

              "&:hover": {
                background: colors.orange.base,
                color: "#fff",
                boxShadow: "none",
              },
            }}
          >
            Unlock Now
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default VaultOpen;
